export const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://fiori-service-api-149308298514.us-central1.run.app"
    : "http://localhost:8080";